import { render, staticRenderFns } from "./CardSelectDisplay.vue?vue&type=template&id=53073240&scoped=true"
import script from "./CardSelectDisplay.vue?vue&type=script&lang=js"
export * from "./CardSelectDisplay.vue?vue&type=script&lang=js"
import style0 from "./CardSelectDisplay.vue?vue&type=style&index=0&id=53073240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53073240",
  null
  
)

export default component.exports